import {
  IPaymentMethodResp,
  PaymentMethodStatusEnum,
} from '@monetize/types/app';
import { FunctionComponent as FC } from 'react';
import MDataTableActions from '../../../components/Monetize/DataTable/MDataTableActions';

import { useDisclosure } from '@chakra-ui/react';
import { PaymentMethodCancelModal } from './PaymentMethodCancelModal';

interface PaymentMethodActionsProps {
  data: IPaymentMethodResp;
}

export const PaymentMethodActions: FC<PaymentMethodActionsProps> = ({
  data,
}: PaymentMethodActionsProps) => {
  const { status, id: paymentMethodId, account } = data;

  const { open: isOpen, onOpen, onClose } = useDisclosure();

  const actions = [
    {
      title: 'Cancel',
      color: 'danger',
      enabled: status === PaymentMethodStatusEnum.ACTIVE,
      action: onOpen,
    },
  ];

  return (
    <>
      <MDataTableActions actions={actions} />
      <PaymentMethodCancelModal
        isOpen={isOpen}
        onClose={onClose}
        paymentMethodId={paymentMethodId}
        accountId={account?.id}
      />
    </>
  );
};
